import React from 'react';
import { getApiTeamDashboardPinUrl } from '../../utilities/urlHelper';
import { canCreateDashboardPin } from '../../utilities/permissionsUtilities';
import { addSuccessMessage } from '../../utilities/notificationUtilities';

class DashboardPinItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDashboardPinned: props.isDashboardPinned,
            dashboardPinId: props.dashboardPinId,
        };
    }

    render() {
        const { isDashboardPinned } = this.state;
        const title = isDashboardPinned ? 'Unpin from bulletin board' : 'Pin to bulletin board';
        return (
            !canCreateDashboardPin()
                ? null
                : <span className="blue col-12 left-align dropdown-option" onClick={this.pinOrUnpinPageFromBulletinBoard}>{title}</span>
        );
    }

    pinOrUnpinPageFromBulletinBoard = () => {
        const type = this.state.isDashboardPinned ? 'DELETE' : 'POST';
        const {
            pageId, externalResourceId, documentId, questionId,
        } = this.props;

        const data = pageId
            ? { pinnableType: 'Page', pinnableId: pageId }
            : externalResourceId
                ? { pinnableType: 'ExternalResource', pinnableId: externalResourceId }
                : documentId
                    ? { pinnableType: 'Document', pinnableId: documentId }
                    : { pinnableType: 'Question', pinnableId: questionId };

        const url = this.state.isDashboardPinned ? `${getApiTeamDashboardPinUrl()}/${this.state.dashboardPinId}` : getApiTeamDashboardPinUrl();

        $.ajax({
            url,
            type,
            data,
        })
            .done(({ message, dashboardPinId }) => {
                addSuccessMessage(message);
                this.setState({
                    isDashboardPinned: !this.state.isDashboardPinned,
                    dashboardPinId,
                });
            })
            .catch(console.error);
    };
}

export default DashboardPinItem;
